'use strict';

import entidades from './entidades.component'

const EntidadesModule = angular
  .module('app.entidades', [])
  .component('entidades', entidades)
  .config(($stateProvider, $urlRouterProvider) => {
    $stateProvider
      .state('entidades', {
        url: '/entidad_cobro',
        component: 'entidades'
      });
    $urlRouterProvider.otherwise('/');
  })
  .name;

export default EntidadesModule



// WEBPACK FOOTER //
// ./src/app/components/entidades/entidades.module.js